import { forwardRef } from "react";
import { SvgIcon } from "@mui/material";

import { CustomizedTooltip } from "components";

import { AssistantBookIcon } from "../../assets";
import { ASSISTANT_NAME } from "../../constants";
import {
  StyledAssistantLauncher,
  AssistantLauncherButton,
  AssistantNewBadge,
} from "./styles";
import { IAssistantLauncherProps } from "./types";

const AssistantLauncher = forwardRef<HTMLDivElement, IAssistantLauncherProps>(
  function AssistantLauncher(
    {
      onOpen,
      launcherPosition,
      dragHandlers,
      dragging,
      hasNewWalkthroughFeatures,
    },
    ref
  ) {
    const label = hasNewWalkthroughFeatures
      ? `Open ${ASSISTANT_NAME} chat: new features to learn`
      : `Open ${ASSISTANT_NAME} chat`;

    return (
      <CustomizedTooltip title={label} placement="left">
        <StyledAssistantLauncher ref={ref} launcherPosition={launcherPosition}>
          <AssistantLauncherButton
            {...dragHandlers}
            dragging={dragging}
            title="Drag to move, or focus and use arrow keys"
            round
            color="secondary"
            aria-label={label}
            onClick={onOpen}
          >
            <SvgIcon component={AssistantBookIcon} inheritViewBox />
            {hasNewWalkthroughFeatures && (
              <AssistantNewBadge aria-hidden>New</AssistantNewBadge>
            )}
          </AssistantLauncherButton>
        </StyledAssistantLauncher>
      </CustomizedTooltip>
    );
  }
);

export default AssistantLauncher;
